import { memo } from 'react';
import { MutationCache, QueryCache, QueryClient, QueryClientConfig, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ChildrenProps } from '@dfl/mui-react-common';

const queryCache = new QueryCache();
const mutationCache = new MutationCache();


const config: QueryClientConfig = {
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    }
  },
};

const queryClient = new QueryClient(config);

const QueryProvider = ({ children }: ChildrenProps) => {   

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools position={'bottom-left'} />
    </QueryClientProvider>
  );
};

export default memo(QueryProvider);
